module.exports = __webpack_public_path__ + "static/media/arrow_up_down.2873d2b3.svg";